import { render, staticRenderFns } from "./changLeaderDes.vue?vue&type=template&id=91fef570&scoped=true"
import script from "./changLeaderDes.vue?vue&type=script&lang=js"
export * from "./changLeaderDes.vue?vue&type=script&lang=js"
import style0 from "./changLeaderDes.vue?vue&type=style&index=0&id=91fef570&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91fef570",
  null
  
)

export default component.exports